import React, { useEffect, useState } from 'react';
import { winnreAuth } from '../../../../utils/axios';
import { getConfig } from '../../../../utils/config';
import { giftSvg } from '../../../../Routes/DealsAndDiscounts/Components/Header/svg';
import LoadingButton from '../../LoadingButton';
import { isRewardsVisible } from '../../../../utils/routing';

const ENV = window.reloy_env.ENV || process.env.REACT_APP_ENV;

const questions = [
    {
        id: -1,
        question: 'Why are you cashing out?',
        type: 'MULTI_MCQ',
        possibleAnswers: [
            'Did not like the products',
            'I Prefer Cash',
            'Not getting the value from products'
        ]
    },
    {
        id: -2,
        question:
            'If you did not find the product you are looking for, share a link and we will source it for you.',
        type: 'FREE',
        optional: true
    },
    {
        id: -3,
        question: 'Any additional feedback to help us improve?',
        type: 'FREE',
        optional: true
    }
];

function MiniSurvey({
    show,
    setShow,
    closeKYCModal,
    showMessage,
    setShowMessage,
    bankstatus
}) {
    const config = getConfig();

    const [comments, setComments] = useState(['', '']);
    const [checkedState, setCheckedState] = useState(
        new Array(questions[0].possibleAnswers.length).fill(false)
    );
    const [formIsValid, setFormIsValid] = useState(false); // Form validation
    // const [showMessage, setShowMessage] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleTextChange = (event, index) => {
        const updatedComments = [...comments];
        updatedComments[index] = event.target.value;
        setComments(updatedComments);
    };

    // Handle MULTI_MCQ answer selection
    const handleMultiMcqClick = (index) => {
        const updatedCheckedState = checkedState.map((item, idx) =>
            idx === index ? !item : item
        );
        setCheckedState(updatedCheckedState);
        setFormIsValid(updatedCheckedState.includes(true));
    };

    const handleSubmit = () => {
        // setLoading(false);
        // setShowMessage(false);
        questions.forEach((question, questionIndex) => {
            let answer = '';
            if (question.type === 'FREE') {
                answer = comments[questionIndex - 1];
            } else if (question.type === 'MULTI_MCQ') {
                const selectedAnswers = question.possibleAnswers.filter(
                    (answer, index) => checkedState[index]
                );
                if (selectedAnswers.length === 0) return;
                answer = selectedAnswers.join(', ');

                const attributes = {
                    'Did not like the products': checkedState[0] ? 'Y' : 'N',
                    'I Prefer Cash': checkedState[1] ? 'Y' : 'N',
                    'Not getting the value from products': checkedState[2]
                        ? 'Y'
                        : 'N'
                };
                window?.webengage?.track('SurveyAnswered', attributes);
            }

            winnreAuth({
                method: 'POST',
                url: `winnre/user/mini-survey-answer/submit`,
                data: {
                    answer: answer,
                    questionId: question.id,
                    answerSource: 'WEB',
                    userSyncClientId: config.id
                }
            })
                .then((res) => {
                    console.log('RESPONSE FROM QUESTION', res);
                    if (res.status === 'FAILED') {
                        console.log('survey response', res);
                        // setShowMessage(true);
                        setShow(false);
                        // setLoading(true);
                        return;
                    }
                    if (question.type === 'FREE') {
                        const attributeName =
                            questionIndex === 1
                                ? 'AdditionalProductRequest'
                                : 'CashAdditionalFeedback';

                        window?.webengage?.track('SurveyAnswered', {
                            [attributeName]: answer
                        });
                    }

                    setShow(false);
                    // console.log('Answer submitted for question:', question.id);
                })
                .catch((error) => {
                    console.error('Submission error:', error);
                });
        });
    };
    // useEffect(() => {
    //     if (showMessage) {
    //         const timer = setTimeout(() => {
    //             setShowMessage(false);
    //             setLoading(false);
    //             setShow(false);
    //         }, 2000);
    //     }
    // }, [showMessage]);

    return (
        <>
            {show && !showMessage && (
                <div className="pt-1 px-4 lg:px-6 flex flex-col gap-3">
                    {questions.map((question, questionIndex) => (
                        <div key={question.id}>
                            <div className="flex flex-row gap-2">
                                <h3 className="font-medium text-base lg:text-lg pr-10 p-2">
                                    {question.question}
                                </h3>
                            </div>

                            {question.type === 'FREE' && (
                                <div className="flex items-center h-16  rounded-lg border border-[#dddddd] p-2">
                                    <textarea
                                        type="text"
                                        className="text-black outline-none w-full"
                                        value={comments[questionIndex - 1]}
                                        onChange={(event) =>
                                            handleTextChange(
                                                event,
                                                questionIndex - 1
                                            )
                                        }
                                    />
                                </div>
                            )}

                            {question.type === 'MULTI_MCQ' && (
                                <div className="grid grid-cols-1 xl:grid-cols-2 gap-2 mt-2">
                                    {question.possibleAnswers.map(
                                        (answer, index) => (
                                            <div
                                                key={index}
                                                className={`cursor-pointer p-2 rounded-md border-2 ${
                                                    checkedState[index]
                                                        ? 'border-primary text-white bg-primary'
                                                        : 'border-gray-100'
                                                }`}
                                                onClick={() =>
                                                    handleMultiMcqClick(index)
                                                }
                                            >
                                                <p>{answer}</p>
                                            </div>
                                        )
                                    )}
                                </div>
                            )}
                        </div>
                    ))}

                    <div className="w-full flex flex-row gap-2 mt-2 justify-start md:justify-end">
                        <button
                            className="sub-btn px-6 text-white disabled:opacity-70 disabled:bg-gray-400 disabled:cursor-not-allowed"
                            onClick={handleSubmit}
                            disabled={!formIsValid}
                        >
                            Submit
                        </button>
                    </div>
                    {isRewardsVisible && (
                <div className="py-1">
                        <div
                            onClick={closeKYCModal}
                            className="flex border-2 rounded-xl mt-4 cursor-pointer py-4 px-4 "
                        >
                            {giftSvg}
                            <div className="ml-2">
                                <h1 className="font-semibold">
                                    Want to claim the whole amount?
                                </h1>
                                <p className="text-sm">
                                    Redeem your reward at our exclusive store
                                </p>
                            </div>
                        </div>
                  
                </div>
            )}
                </div>
                
)}

  {/* {bankstatus != 'COMPLETED' &&  showMessage && show && (
    <div className="flex flex-col justify-center items-center py-4 gap-2 ">
    <p className="mt-1 text-base ">
        Thank you for your feedback!
    </p>
    <p className="mt-1 text-base">
        {' '}
        Your response has been submitted successfully.
    </p>
    <p className="mt-2 text-base">
        Redirecting you to the next step shortly...
    </p>
    <div className="mt-2">
        <LoadingButton hideButton={true} loading={loading} />
    </div>
</div>
  )} */}
       
            {/* {showMessage && (
                <div className="flex flex-col justify-center items-center py-4 gap-2 ">
                    <p className="mt-1 text-base ">
                        Thank you for your feedback!
                    </p>
                    <p className="mt-1 text-base">
                        {' '}
                        Your response has been submitted successfully.
                    </p>
                    <p className="mt-2 text-base">
                        Redirecting you to the next step shortly...
                    </p>
                    <div className="mt-2">
                        <LoadingButton hideButton={true} loading={loading} />
                    </div>
                </div>
            )} */}
            {/* {isRewardsVisible && (
                <div className="px-4 lg:px-6 py-1">
                    {show && (
                        <div
                            onClick={closeKYCModal}
                            className="flex border-2 rounded-xl mt-4 cursor-pointer py-4 px-4 "
                        >
                            {giftSvg}
                            <div className="ml-2">
                                <h1 className="font-semibold">
                                    Want to claim the whole amount?
                                </h1>
                                <p className="text-sm">
                                    Redeem your reward at our exclusive store
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            )} */}
        </>
    );
}

export default MiniSurvey;
